import React from 'react';
import classnames from 'classnames';
import {useEffect} from '@wordpress/element';
import {Stack, Box} from '@lapilli-ui/components';

import {dispatchEvent} from "../../../../base/utils";
import {useStoreSearch} from "@ywcas/base-context/hooks";
import {PopoverWithContent} from "../../../../base/components";
import {useSearchContext} from '../../context';
import {YWCAS_HAS_AUTOCOMPLETE, YWCAS_MIN_CHARS, YWCAS_ZERO_RESULTS, YWCAS_FUZZY_RESULTS} from '../../../../config';


const FrontendBlock = ({children, className}) => {

    if (!YWCAS_HAS_AUTOCOMPLETE) {
        return null;
    }
    const {query, inputFocused, setInputFocused} = useSearchContext();
    const {getResults} = useStoreSearch();
    const results = getResults();
    useEffect(() => {
        const checkIfClickedOutside = e => {
            const filledBox = document.getElementsByClassName('wp-block-yith-filled-block');
            if (!(e.target.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('ywcas-input-field-wrapper'))) {
                if (filledBox[0] && !filledBox[0].contains(e.target)) {
                    setInputFocused(null)
                }
            }
        }
        document.addEventListener("click", checkIfClickedOutside)
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [setInputFocused]);

    useEffect(() => {
        dispatchEvent('ywcas-blocks_render_blocks_frontend', {
            element: document.body.querySelector(
                '.wp-block-yith-search-block'
            ),
        });
    }, []);
    const classes = classnames(
        'ywcas-popover-results',
        results.results.totalResults === 0 ? 'no-results' : ''
    );

    if (query === '' || query.length < YWCAS_MIN_CHARS) {
        return null;
    }

    if (inputFocused) {
        return (
            <>
                <PopoverWithContent
                    className={classes}
                    anchorRef={inputFocused}
                    verticalMargin={5}
                    forceMinWidth
                    forceInView={false}
                    fixed={true}
                    sx={{
                        '&.no-results hr.wp-block-separator': {
                            display: 'none'
                        },
                        '& hr.wp-block-separator': {
                            marginLeft: '0',
                            marginRight: '0'
                        }
                    }}>
                    <Stack direction='column' spacing={4} className='wp-block-yith-filled-block'>
                        {results.results.fuzzyToken &&  results.results.fuzzyToken.length > 0 &&
                            <Box sx={{lineHeight: '2.5em'}}>{`${YWCAS_ZERO_RESULTS} "${query}"`}</Box>}
                        <Box className={className}>
                            {results.results.fuzzyToken && results.results.fuzzyToken.length > 0 && <Box sx={{marginBottom: '15px'}}>
                                <strong>{`${YWCAS_FUZZY_RESULTS} ${results.results.fuzzyToken}:`}</strong>
                            </Box>
                            }
                            {children}
                        </Box>
                    </Stack>
                </PopoverWithContent>
            </>
        );
    }
    return null;
}

export default FrontendBlock;